var Properties = function () {

    var comp = $('[data-component="properties"]');

    this.init = function () {

        this.properties();

    }

    this.properties = function () {

        $('.icon').on('click', function() {
            $(this).parents('[data-component="properties"]').find('.content').slideToggle(300);
            $(comp).toggleClass('active');
        })

    }

    return this.init();

}
